import { BackgroundAction } from '../BackgroundAction'
import { quarantineBackgroundAction } from './api'

export const ExportBackgroundAction = new BackgroundAction({
  api: quarantineBackgroundAction,
})
